import gql from 'graphql-tag';

export default gql`
  fragment scheduledEventsFields on ScheduledEvent {
    id
    name
    groupId
    enabled
    roomId
    floorId
    intent
    hours
    dimming
    minutes
    repeatMonday
    repeatTuesday
    repeatWednesday
    repeatThursday
    repeatFriday
    repeatSaturday
    repeatSunday
    duration
    onEnd
    mode {
      ...lightModeFields
    }
  }
`;
